import { SelectOption } from '../../types'

const selectRenderer = (
  value: SelectOption | Array<SelectOption> | undefined,
): string => {
  return value
    ? Array.isArray(value)
      ? value.map((option) => option.label).join(', ')
      : value.label
    : ''
}

export default selectRenderer
